import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: ReactNode;
}

export const Portal = ({ children }: PortalProps) => {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(() =>
    typeof document === "undefined" ? null : document.body
  );

  useEffect(() => setMountNode(document.body), []);

  if (!mountNode) return null;

  return createPortal(children, mountNode);
};
